import React, { useState, useEffect } from "react";

const MilestoneAnimation = ({ onComplete }) => {
  const [currentMilestone, setCurrentMilestone] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setCurrentMilestone(1), 500),
      setTimeout(() => setCurrentMilestone(2), 1500),
      setTimeout(() => setCurrentMilestone(3), 2500),
      setTimeout(() => onComplete?.(), 4000),
    ];
    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  return (
    // <div className="w-full h-full flex flex-col">
    <div className="min-h-[600px] md:min-h-[750px] bg-white flex items-center justify-center p-8">
      <div className="w-full max-w-4xl">
        <div className="relative">
          {/* Progress bar background */}
          <div className="absolute top-20 left-0 right-0 h-1 bg-gray-200"></div>

          {/* Progress fill */}
          <div
            className="absolute top-20 left-0 h-1 bg-teal-500 transition-all duration-1000 ease-out"
            style={{ width: `${(currentMilestone / 3) * 100}%` }}
          ></div>

          {/* Milestone circles */}
          <div className="relative flex justify-between items-start">
            {[1, 2, 3].map((milestone) => (
              <div key={milestone} className="flex flex-col items-center">
                <div
                  className={`w-32 h-32 rounded-full border-8 flex items-center justify-center text-4xl font-bold transition-all duration-500 ${
                    currentMilestone >= milestone
                      ? "bg-teal-500 border-teal-600 text-white scale-110 shadow-2xl animate-[milestone-pop_0.5s_ease-out]"
                      : "bg-white border-gray-300 text-gray-300"
                  }`}
                >
                  {currentMilestone > milestone ? (
                    <svg
                      className="w-16 h-16"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    milestone
                  )}
                </div>
                <p
                  className={`mt-6 text-lg font-bold uppercase tracking-wider transition-all duration-500 ${
                    currentMilestone >= milestone
                      ? "text-teal-600"
                      : "text-gray-400"
                  }`}
                >
                  Milestone {milestone}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ✅ React-compatible style (no jsx prop) */}
      <style>{`
        @keyframes milestone-pop {
          0% { transform: scale(0.8); opacity: 0; }
          50% { transform: scale(1.2); }
          100% { transform: scale(1.1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default MilestoneAnimation;
